__turbopack_context__.v({
  "accordion": "_-module__rZNuJq__accordion",
  "icon": "_-module__rZNuJq__icon",
});
